.page {
  padding: var(--space-4, 1rem);
  max-width: 48rem;
  margin: 0 auto;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  flex-wrap: wrap;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.card {
  background: var(--card);
  border: 1px solid var(--paper-2);
  border-radius: var(--radius-soft);
  padding: 1rem;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.visitor {
  font-family: var(--font-mono);
  font-weight: 600;
  margin: 0;
}

.repeatBadge {
  font-size: var(--text-min-body, 0.875rem);
  color: var(--muted);
  border: 1px solid var(--paper-2);
  border-radius: var(--radius-soft);
  padding: 0.1rem 0.5rem;
}

.time {
  color: var(--muted);
  font-size: var(--text-min-body, 0.875rem);
}

.pastedText {
  white-space: pre-wrap;
  margin: 0.5rem 0;
  font-family: var(--font-mono);
  font-size: var(--text-min-body, 0.875rem);
}

.labels {
  list-style: none;
  margin: 0.5rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.label {
  font-size: var(--text-min-body, 0.875rem);
  border-left: 3px solid var(--paper-2);
  padding-left: 0.5rem;
}

.label[data-disposition='confirmed'] {
  border-left-color: var(--ok);
}

.label[data-disposition='rejected'] {
  border-left-color: var(--stop);
}

.noLabels {
  color: var(--muted);
  font-size: var(--text-min-body, 0.875rem);
  margin: 0.5rem 0 0;
}

.empty {
  color: var(--muted);
}
